import React, {useState} from 'react';

const DropDownSearch = (props) => {
    const [visible, setVisible] = useState(false);
    const [query, setQuery] = useState();
    return (
        <>
        <span onClick={e => setVisible(true)}>
            <span className='icon icon-search'></span>
        </span>
        {visible? 
        <div className='dropSearch'>
            <div>
                <input placeholder='جستجو' value={query} onChange={e => setQuery(e.target.value)} />
                <button className='originalButton' onClick={e => {props.search(query); setVisible(false)}}>جستجو</button>
            </div>
        </div>
        : null}
        </>
    );
}

export default DropDownSearch;